<template>
  <BCard>
    <div class="d-flex align-items-center mb-[20px]">
      <button
        class="mr-1 rounded-lg button-primary w-[32px] h-[32px]"
        @click="$router.go(-1)"
      >
        <span
          class="k-arrow-left-2 h-100 font-bold text-10 pt-[3px] align-middle mx-[5px]"
        />
      </button>
      <strong class="my-0 text-dark text-10">Detail</strong>
    </div>
    <div
      class="d-flex border p-[16px] rounded-[12px]"
      style="min-height: 146px;"
    >
      <div class="d-flex flex-column gap-12">
        <h4 class="m-0">
          <strong>{{ detailTrainingProgram.name }}</strong>
        </h4>
        <p class="m-0">
          {{ DAY_MONTH_YEAR(detailTrainingProgram.start_date) }} -
          {{ DAY_MONTH_YEAR(detailTrainingProgram.end_date) }}
        </p>
        <p class="m-0">
          {{ detailTrainingProgram.training_center_name }}
        </p>
        <div :class="detailTrainingProgram.level">
          {{ trainingLevel[detailTrainingProgram.level] }}
        </div>
      </div>
      <b-button
        v-b-modal.modalDelete
        size="md"
        class="ml-auto align-self-end"
        variant="outline-primary"
        :disabled="listParticipant.length > 0"
        @click="selectItem($route.params.id, false)"
      >
        Delete
      </b-button>
      <button
        class="ml-1 button-primary px-[34px] py-[8px] align-self-end"
        :disabled="detailTrainingProgram.is_publish"
        @click="$router.push({ name: 'training-program-edit' })"
      >
        Edit
      </button>
    </div>
    <NewsTraining
      v-if="detailTrainingProgram.is_publish"
      :loading="loadNews"
      :preview="newsPreview"
      :meta="newsMeta"
      @openEditor="fireNewsEditor"
      @openResetModal="fireResetNewsModal"
      @updateImage="updateNewsImage"
    />
    <hr class="mt-[24px] mb-[4px] border-none outline-none h-px bg-[#E2E2E2]">
    <EditNews
      :model.sync="newsModel"
      :access-option="newsAccessOption"
      :existing="newsPreview"
      @close="hideNewsEditor"
      @save="() => updateNews('body')"
    />
    <ConfirmPopup
      id="publish-news-modal"
      title="Publish berita sekarang?"
      confirm-text="Ya, Publish"
      @close="newsModel.visibility = newsPreview.visibility"
      @confirm="publishNews"
    >
      <div class="w-full flex justify-end">
        <Visibility
          :access.sync="newsModel.visibility"
          :access-option="newsAccessOption"
        />
      </div>
    </ConfirmPopup>
    <ConfirmPopup
      :type="popupData.type"
      :title="popupData.title"
      :cancel-text="popupData.cancelText"
      :confirm-text="popupData.confirmText"
      @confirm="popupConfirmAction"
    />
    <BOverlay
      id="scroll"
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <section>
        <div class="d-flex align-items-center mb-[20px]">
          <strong class="my-[20px] text-dark text-10">Partisipan</strong>
          <div
            class="d-flex rounded-lg align-items-center border search-bar ml-auto"
          >
            <span
              class="k-search-normal-1 h-100 font-bold text-10 pt-[7px] align-middle mx-[5px]"
            />
            <BFormInput
              v-model="keyword"
              placeholder="Cari Nama"
              class="border-0"
              @input="handleSearch()"
            />
          </div>
          <b-dropdown
            id="dropdown-1"
            class="filter ml-1"
            no-caret
            variant="primary"
            toggle-class="text-decoration-none p-0 button-primary rounded-lg"
          >
            <h5>Filter</h5>
            <template #button-content>
              <button
                class="button-primary border-0"
                style="padding: 8px"
              >
                <b-img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
                  class="h-[20px]"
                />
              </button>
            </template>
            <b-dropdown
              id="dropdown-2"
              class="w-100"
              toggle-class="text-left"
              variant="none"
              left
              no-caret
              dropright
            >
              <template #button-content>
                <span class="hover-salmon text-6 w-100">Status</span>
              </template>
              <b-dropdown-form style="width: 200px">
                <b-form-checkbox
                  v-for="(status, index) in listStatus"
                  :key="index"
                  v-model="filterSelected"
                  :name="`filter-status`"
                  class="text-6 mb-1"
                  :value="status.value"
                  @change="getListParticipan(true)"
                >
                  {{ status.text }}
                </b-form-checkbox>
              </b-dropdown-form>
            </b-dropdown>
            <h5
              class="pb-0 pt-1 font-bold text-danger w-100 cursor-pointer"
              @click="resetFilter()"
            >
              Reset filter
            </h5>
          </b-dropdown>
          <button
            class="ml-1 px-1 button-primary py-[8px]"
            :disabled="detailTrainingProgram.is_publish"
            @click="showAddParticipant = true"
          >
            <strong>Tambah Partisipan</strong>
          </button>
        </div>
        <validation-observer ref="formRules">
          <BTable
            :items="listParticipant"
            :fields="fields"
            empty-text="Tidak ada data yang ditampilkan."
            responsive
            show-empty
            sticky-header="500px"
            @scroll.native="handleScroll"
          >
            <template #cell(id)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(notes)="data">
              <span
                v-if="data.item.notes === 'fail'"
                class="failed"
              >Tidak Lulus</span>
              <span
                v-else-if="data.item.notes === 'pass'"
                class="passed"
              >Lulus</span>
              <span
                v-else
                class="passed"
              >-</span>
            </template>
            <template #cell(status)="data">
              <span
                v-if="data.item.status === 'registered'"
                class="registered"
              >Registered</span>
              <span
                v-else-if="data.item.status === 'hired'"
                class="hired"
              >Hired</span>
              <span
                v-else-if="data.item.status === 'selected'"
                class="selected"
              >Selected</span>
              <span
                v-else-if="data.item.status === 'non job'"
                class="non-job"
              >Non-Job</span>
              <span
                v-else
                class="registered"
                style="text-transform: capitalize;"
              >{{ data.item.status }}</span>
            </template>
            <template #cell(score)="data">
              <validation-provider
                #default="{ errors }"
                name="Score"
                :rules="{ numeric: true, max_value: 100 }"
              >
                <b-form-input
                  v-model="data.item.score"
                  :disabled="detailTrainingProgram.is_publish"
                  @keyup.enter="errors[0] ? false : updateParticipant(data.item)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </template>
            <template #cell(validation)="data">
              <div class="d-flex">
                <validation-provider
                  #default="{ errors }"
                  name="Validasi"
                  :rules="{ regex: /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/ }"
                >
                  <b-form-input
                    v-model="data.item.validation"
                    :disabled="detailTrainingProgram.is_publish"
                    class="text--blue"
                    @keyup.enter="errors[0] ? false : updateParticipant(data.item, data.index)"
                    @keyup.prevent
                  />
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Validasi harus berupa url</small>
                </validation-provider>
                <button
                  class="ml-1 rounded-lg button-primary w-[32px] h-[32px]"
                  :disabled="!data.item.validation || detailTrainingProgram.is_publish"
                  @click="toLink(data.item.validation)"
                >
                  <span
                    class="k-arrow-right-2 h-100 font-bold text-10 pt-[3px] align-middle mx-[5px]"
                  />
                </button>
              </div>
            </template>
            <template #cell(action)="data">
              <div class="flex justify-end items-center">
                <BButton
                  v-b-modal.modalDelete
                  class="btn-icon mr-50"
                  size="sm"
                  variant="flat-warning"
                  :disabled="detailTrainingProgram.is_publish"
                  @click="selectItem(data.item.id, true)"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/trash.svg"
                    alt="Komerce"
                  >
                </BButton>
              </div>
            </template>
          </BTable>
        </validation-observer>
      </section>
    </BOverlay>
    <ModalAdd
      v-if="showAddParticipant"
      @close="onCloseModal()"
    />
    <ModalDelete
      :id-item="parseInt(idItem)"
      :is-participant="isParticipant"
      @deleted="getListParticipan(true)"
    />
  </BCard>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { komtimAxiosIns } from '@/libs/axios'
import {
  required,
  numeric,
  max_value,
} from '@validations'
import { alertError, alertSuccess } from '@toast'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { convertBlob, tableParticipant } from './config'
import ModalAdd from './ModalAdd.vue'
import ModalDelete from './ModalDelete.vue'
import EditNews from './news-training/EditNews.vue'
import ConfirmPopup from './ConfirmPopup.vue'
import Visibility from './news-training/Visibility.vue'
import NewsTraining from './news-training/NewsTraining.vue'

export default {
  components: {
    ModalAdd,
    ModalDelete,
    ValidationProvider,
    ValidationObserver,
    EditNews,
    ConfirmPopup,
    Visibility,
    NewsTraining,
  },
  data() {
    return {
      fields: tableParticipant,
      showAddParticipant: false,
      detailTrainingProgram: {},
      keyword: '',
      filterSelected: [],
      items: [],
      listParticipant: [],
      isParticipant: null,
      idItem: 0,
      loading: false,
      limit: 20,
      offset: 0,
      lastData: false,
      alertError,
      alertSuccess,
      DAY_MONTH_YEAR,

      listStatus: [
        {
          text: 'Register',
          value: 'registered',
        },
        {
          text: 'Selected',
          value: 'selected',
        },
        {
          text: 'Hired',
          value: 'hired',
        },
        {
          text: 'Non-job',
          value: 'non job',
        },
      ],
      required,
      numeric,
      max_value,
      trainingLevel: { basic: 'Dasar', specific: 'Spesifik', mature: 'Pematangan' },
      newsAccessOption: [
        { value: 'public', label: 'Public', icon: 'k-global' },
        { value: 'partner', label: 'Partner Terasign', icon: 'k-people' },
      ],
      newsMeta: {
        image: 'https://storage.googleapis.com/komerce/assets/Default-Photo-Web.png',
        updated_at: '',
        published_at: null,
      },
      newsModel: {
        visibility: 'public',
        title: '',
        body: '',
      },
      newsPreview: {
        visibility: 'public',
        title: '',
        body: '',
      },
      loadNews: {
        all: false,
        image: false,
        body: false,
        publish: false,
      },
      popupData: {
        type: 'warning',
        title: 'Yakin reset berita?',
        cancelText: 'Batalkan',
        confirmText: 'Ya, Reset',
        trigger: 'reset-news',
      },
    }
  },
  created() {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (
        bvEvent.componentId === 'dropdown-2'
        || bvEvent.componentId === 'dropdown-3'
        || bvEvent.componentId === 'dropdown-4'
      ) {
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (
        bvEvent.componentId === 'dropdown-2'
        || bvEvent.componentId === 'dropdown-3'
        || bvEvent.componentId === 'dropdown-4'
      ) {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  async mounted() {
    await this.getDetailTrainingProgram()
    this.getTrainingNews()
    this.getListParticipan()
  },
  methods: {
    async getDetailTrainingProgram() {
      this.loading = true

      const url = `v1/training_programs/${this.$route.params.id}`
      await komtimAxiosIns
        .get(url)
        .then(async res => {
          const { data } = res.data
          this.detailTrainingProgram = await data
        })
        .catch(err => {
          this.alertError(err)
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getListParticipan(reset = false) {
      if (reset) {
        this.offset = 0
        this.listParticipant = []
        this.lastData = false
      }
      if (this.loading || this.lastData) return
      this.loading = true

      const params = `offset=${this.offset}&limit=${this.limit}&keyword=${this.keyword}&status=${this.filterSelected.join(',')}`
      const url = `v1/training_programs/${this.$route.params.id}/participants?${params}`
      await komtimAxiosIns
        .get(url)
        .then(async res => {
          const { data } = res.data
          if (data) {
            this.listParticipant.push(...data)
            this.offset += data.length
          }
          this.lastData = !data || data.length === 0 || data.length < this.limit
        })
        .catch(err => {
          this.alertError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.getListParticipan()
      }
    },
    onCloseModal() {
      this.showAddParticipant = false
      this.getListParticipan(true)
    },
    selectItem(id, isParticipant) {
      this.idItem = id
      this.isParticipant = isParticipant
    },
    async updateParticipant(param, index) {
      const payload = {
        score: parseInt(param.score, 10),
        validation: param.validation,
      }

      const url = `v1/training_programs/participants/${param.id}/update`
      await komtimAxiosIns
        .put(url, payload)
        .then(res => {
          const text = 'Berhasil mengubah data'
          this.alertSuccess(text)

          this.getListParticipan(true)
        })
        .catch(error => {
          this.alertError(error)
        })
    },
    handleSearch: _.debounce(function search() {
      this.getListParticipan(true)
    }, 1000),
    resetFilter() {
      this.filterSelected = []
      this.getListParticipan(true)
    },
    toLink(link) {
      window.open(link, '_blank')
    },
    async getTrainingNews() {
      if (!this.detailTrainingProgram.is_publish) return
      try {
        this.loadNews.all = true
        const res = await komtimAxiosIns.get(`v1/training_programs/${this.$route.params.id}/news`)
        const {
          image, published_at, updated_at, ...news
        } = res.data.data
        Object.keys(news).forEach(key => {
          this.newsModel[key] = news[key]
          this.newsPreview[key] = news[key]
        })
        this.newsMeta = { image, updated_at, published_at }
      } catch (error) {
        this.$toast_error({ message: 'Gagal Mengambil Data Training News' })
      } finally {
        this.loadNews.all = false
      }
    },
    fireNewsEditor() {
      this.$bvModal.show('edit-news-modal')
      this.popupData = {
        type: 'success',
        title: 'Berita tersimpan!',
        cancelText: 'Oke',
        confirmText: '',
        trigger: '',
      }
    },
    hideNewsEditor() {
      Object.keys(this.newsPreview).forEach(key => { this.newsModel[key] = this.newsPreview[key] })
    },
    async updateNews(toUpdate, image) {
      try {
        this.loadNews[toUpdate] = true
        const formData = new FormData()
        Object.keys(this.newsModel).forEach(key => formData.append(key, this.newsModel[key]))
        formData.append('image', image || null)
        await komtimAxiosIns.patch(`v1/training_programs/${this.$route.params.id}/news`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        this.newsMeta.published_at = null
        this.newsMeta.updated_at = new Date().toISOString()
        if (image) {
          this.newsMeta.image = await convertBlob(image)
          return
        }
        Object.keys(this.newsModel).forEach(key => { this.newsPreview[key] = this.newsModel[key] })
        setTimeout(() => this.$bvModal.show('global-default-modal'), 0)
      } catch (error) {
        this.$toast_error({ message: 'Gagal Mengubah Data Training News' })
      } finally {
        this.loadNews[toUpdate] = false
      }
    },
    updateNewsImage(e) {
      const file = e.target.files[0]
      if (!file) return
      if (Math.round((file.size / 1024) * 100) / 100 > 5000) {
        this.$toast_error({ message: 'Maksimal ukuran file adalah 5 mb' })
        return
      }
      this.updateNews('image', file)
    },
    fireResetNewsModal() {
      this.popupData = {
        type: 'warning',
        title: 'Yakin reset berita?',
        cancelText: 'Batalkan',
        confirmText: 'Ya, Reset',
        trigger: 'reset-news',
      }
      this.$bvModal.show('global-default-modal')
    },
    async resetNews() {
      try {
        this.loadNews.all = true
        await komtimAxiosIns.delete(`v1/training_programs/${this.$route.params.id}/news`)
        setTimeout(() => {
          this.newsMeta.updated_at = new Date().toISOString()
          this.popupData = {
            type: 'success',
            title: 'Berita tereset!',
            cancelText: 'Oke',
            confirmText: '',
            trigger: '',
          }
          this.$bvModal.show('global-default-modal')
        }, 0)
      } catch (error) {
        this.$toast_error({ message: 'Gagal Mereset Data Training News' })
      }
      await this.getTrainingNews()
    },
    async publishNews() {
      try {
        this.loadNews.publish = true
        const { visibility } = this.newsModel
        await komtimAxiosIns.post(`v1/training_programs/${this.$route.params.id}/news`, { visibility })
        this.newsMeta.updated_at = new Date().toISOString()
        this.newsMeta.published_at = new Date().toISOString()
        this.newsPreview.visibility = visibility
        setTimeout(() => {
          this.popupData = {
            type: 'success',
            title: 'Berita terpublish!',
            cancelText: 'Oke',
            confirmText: '',
            trigger: '',
          }
          this.$bvModal.show('global-default-modal')
        }, 0)
      } catch (error) {
        this.$toast_error({ message: 'Gagal Mempublish Data Training News' })
      } finally {
        this.loadNews.publish = false
      }
    },
    popupConfirmAction() {
      if (this.popupData.trigger === 'reset-news') {
        this.resetNews()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style/Index.scss';
</style>
